import styled from '@emotion/styled';

export const DateDropDownPickerWrapper = styled('div', { label: 'DateDropDownPickerWrapper' })`
    display: flex;
    justify-content: space-between;
    align-items: center;

    > div {
        width: 32%;
    }
`;

export const SelectWrapper = styled('div', { label: 'SelectWrapper' })`
    position: relative;
    width: 100%;

    select {
        appearance: none;
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 3px;
        box-shadow: inset 0 3px 5px 0 rgba(0, 0, 0, 0.03);
        color: #2b2b2b;
        cursor: pointer;
        font-size: 16px;
        font-weight: 100;
        height: 48px;
        line-height: 3;
        outline: none;
        padding: 0 12px;
        width: 100%;

        &:focus {
            box-shadow: 5px 8px 20px -8px rgba(0, 0, 0, 0.1);
        }

        &:disabled {
            opacity: 0.3;
        }

        option[value=''],
        option:empty:not([value]) {
            display: none;
        }
    }

    &::before,
    &::after {
        content: '';
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%) translateX(50%) rotate(45deg);
        width: 4px;
        height: 10px;
        border-radius: 2px;
        background: #ccc;
        pointer-events: none;
    }

    &::after {
        transform: translateY(-50%) translateX(-50%) rotate(-45deg);
    }
`;
